(function (window, $) {
	'use strict';

	// Re-initialize page widgets on route changes without stacking handlers.
	function initBlinkUi() {

	// Keep optional GSAP hook classes in sync with newly routed content.

	$('.banner, .section, .content, .main-title, .about-section, .feature-item, .team-item, .work-item').addClass('gsap-fade-up');
	$('.parallax-bg').addClass('gsap-parallax');

    // Start Menu JS
	$(window).off('scroll.blinkNav').on('scroll.blinkNav', function() {
		if ($(this).scrollTop() > 50) {
			$('.main-nav').addClass('menu-shrink');
		} else {
			$('.main-nav').removeClass('menu-shrink');
		}
    });
	$(window).triggerHandler('scroll.blinkNav');

	// Mean Menu JS
	var $mobileNav = $('.mobile-nav');
	if ($('.mean-menu').length && $mobileNav.length && !$mobileNav.data('blink-meanmenu-init')) {
		$mobileNav.data('blink-meanmenu-init', true);
		$('.mean-menu').meanmenu({ meanScreenWidth: '991' });
	}
	
	// Search Box JS
	$('.search-toggle').not('.opened').addClass('closed');
	$('.search-toggle .search-icon').off('click.blinkSearch').on('click.blinkSearch', function(e) {
		if ($('.search-toggle').hasClass('closed')) {
		$('.search-toggle').removeClass('closed').addClass('opened');
		$('.search-toggle, .search-area').addClass('opened');
		$('#search-terms').focus();
		} else {
		$('.search-toggle').removeClass('opened').addClass('closed');
		$('.search-toggle, .search-area').removeClass('opened');
		}
	});

	// Sidebar Modal JS
	$('.modal a').not('.dropdown-toggle').off('click.blinkModal').on('click.blinkModal', function() {
		$ ('.modal').modal ('hide');
	});

	// Banner Slider JS
	var $bannerSlider = $('.banner-slider').not('.owl-loaded');
	if ($bannerSlider.length) $bannerSlider.owlCarousel({
		items: 1,
		loop: true,
		margin: 15,
		singleItem: true,
		nav: false,
		dots: true,
		animateOut: 'fadeOut',
		smartSpeed: 1000,
		autoplay: true,
		autoplayTimeout: 4000,
		autoplayHoverPause: true,
    });

	// Testimonial Slider JS
	var $testimonialSlider = $('.testimonial-slider').not('.owl-loaded');
	if ($testimonialSlider.length) $testimonialSlider.owlCarousel({
		items: 1,
		loop: true,
		margin: 15,
		singleItem: true,
		nav: false,
		dots: false,
		smartSpeed: 1000,
		autoplay: true,
		autoplayTimeout: 4000,
		autoplayHoverPause: true,
	});

	// Upcoming Movies Slider JS
	// Angular re-initializes widgets after each route change; without this guard,
	// navigating back
	// to a page with this slider would call owlCarousel() on an element that's
	// already initialized, duplicating the .owl-nav prev/next arrow buttons it
	// creates instead of leaving the existing, working instance alone.
	var $upcomingMoviesSlider = $('.upcoming-movies-slides');
	if ($upcomingMoviesSlider.length && !$upcomingMoviesSlider.hasClass('owl-loaded')) {
		$upcomingMoviesSlider.owlCarousel({
			items: 1,
			slideSpeed: 2000,
			nav: true,
			autoplay: true,
			dots: false,
			autoplayHoverPause: true,
			loop: true,
			navText: [
				'<i class="bx bx-chevron-left"></i>',
				'<i class="bx bx-chevron-right"></i>'
			]
		});
	}

	// Popup Youtube JS
	$('.popup-youtube').not('.blink-popup-initialized').addClass('blink-popup-initialized').magnificPopup({
		disableOn: 320,
		type: 'iframe',
		mainClass: 'mfp-fade',
		removalDelay: 160,
		preloader: false,
		fixedContentPos: false,
	});

	// Accordion JS
	$('.accordion > li:eq(0) a').addClass('active').next().slideDown();
	$('.accordion a').off('click.blinkAccordion').on('click.blinkAccordion', function(j) {
		var dropDown = $(this).closest('li').find('p');
		$(this).closest('.accordion').find('p').not(dropDown).slideUp();
		if ($(this).hasClass('active')) {
			$(this).removeClass('active');
		} 
		else {
			$(this).closest('.accordion').find('a.active').removeClass('active');
			$(this).addClass('active');
		}
		dropDown.stop(false, true).slideToggle();
		j.preventDefault();
	});

	// Back to Top JS
	// Guarded for the same reason as the Upcoming Movies slider above: this script
	// re-initializes widgets after every route change. Without this check it would append
	// a second #toTop arrow button (with its own scroll/click handlers) on top of
	// the existing one instead of reusing it.
	if (!$('#toTop').length) {
		$('body').append('<div id="toTop" class="back-to-top-btn"><i class="bx bxs-up-arrow-alt"></i></div>');
	}
	$(window).off('scroll.blinkBackToTop').on('scroll.blinkBackToTop', function() {
		var $button = $('#toTop');
		var shouldShow = $(this).scrollTop() > 0;
		// Run a fade only when visibility changes, not on every scroll tick.
		if ($button.data('blink-visible') === shouldShow) return;
		$button.data('blink-visible', shouldShow);
		$button.stop(true, true)[shouldShow ? 'fadeIn' : 'fadeOut'](180);
	});
	$(window).triggerHandler('scroll.blinkBackToTop');
	$('#toTop').off('click.blinkBackToTop').on('click.blinkBackToTop', function(){
		// Bootstrap's reboot CSS sets `scroll-behavior: smooth` on <html> (see
		// node_modules/bootstrap/scss/_reboot.scss), which fights jQuery's
		// .animate({ scrollTop }) step-by-step scrollTop writes and stalls the
		// scroll instead of moving it. Using the native scrollTo API lets the
		// browser's own (already smooth) scroll handling do the work instead of
		// competing with it.
		var reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
		window.scrollTo({ top: 0, left: 0, behavior: reducedMotion ? 'auto' : 'smooth' });
		return false;
	});
	
	}

	window.blinkInitUi = initBlinkUi;
	$(initBlinkUi);
})(window, jQuery);
